import api from "../api";

export default function getFeedSources() {
    return api.get(`/admin/feedSources`);
}
